import React, { Component } from "react";
import Dialog from "../dialog";
import DialogInput from "../input";
import LanguageInput from "../languagesinput";


class AddSRT extends Dialog
{
  constructor(props) 
  {
    super(props);

    const title = {
        en:"Add a SRT Subtitles File", 
        fr:"Ajouter un fichier sous-titres SRT",
      };
    this.state.title = title;

    this.state.buttons = 
    [
      //{type:"text", disabled:true,text:{fr:"Accepter",en:"Accept"},key:"accept"},
      //{type:"text", disabled:false,text:{fr:"Refuser",en:"Decline"}, key:"decline"},
      {type:"back", disabled:false},
      {type:"ok", disabled:true},
      
    ]

    this.handleButton =  this.handleButton.bind(this);

    this.formulaire = 
      {
        title: "",
        type: 0,
        filename: "",
        language: "fr-FR",
        uploadfile: null,
        ext: '',
        subtype:0,
        STLDatas: null,
      }
   

        this.formulaire.title = this.props.STLFile;
        this.formulaire.nbst = this.props.STLDatas.subtitles.length;
        this.formulaire.subtype = "";
        this.formulaire.filename = this.props.STLFile;
        this.formulaire.STLDatas = this.props.STLDatas;
        //this.formulaire.ext = this.getFileExtension(this.props.STLFile)
  
      this.titleRef = React.createRef();
      this.uploadRef = React.createRef();
      this.filenameRef = React.createRef();
      this.languageRef = React.createRef();

      this.handleOnChange = this.handleOnChange.bind(this);

      this.onQuit = this.onQuit.bind(this)
      this.onValid = this.onValid.bind(this)


   
    
  }
  getFileExtension(file)
  {
      const filename = file.name; // Get the file name
      const index = filename.indexOf(".");
      if (index === -1) return "";

      const fileExtension = filename.split(".").pop().toLowerCase(); // Extract the file extension
      return fileExtension;

  }


  onValid()
  {
    
  }

  onQuit()
  {
    this.props.onButton("back", this.formulaire);    
  }

  removeExtension(filename) 
    {
      const index = filename.indexOf(".");
      if (index === -1) return filename;
      return filename.split('.').slice(0, -1).join('.');
    }

  handleOnChange()
  {
      this.formulaire.title = this.titleRef.current.getValue();

      
      this.formulaire.language = this.languageRef.current.getValue();
      




      if (this.formulaire.title.trim() != "")
      {
        this.setDisabledButtonByType("ok", false);
        this.setDisabledButtonByKey("accept", false);
      }
      else
      {
        this.setDisabledButtonByType("ok", true);
        this.setDisabledButtonByKey("accept", true);
      }

      
  }


  handleButton(buttonkey)
  {
    
    
    this.props.onButton(buttonkey, this.formulaire);

  }

  render()
  {


    const retour =
    (
      <>
      <br/>
        <DialogInput
          value = {this.formulaire.title}
          disabled={false}
          autoFocus = {true}
          title = {this.context.language=="fr"?"Titre":"Title"}
          width = "400px"
          ref = {this.titleRef}
          onChange =  {this.handleOnChange}

        />
    <br/>

      <DialogInput
                value = {this.formulaire.filename}
                disabled={false}
                autoFocus = {false}
                ref = {this.filenameRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "400px"
                title = {this.context.language=="fr"?"Fichier à téléverser":"File to upload"}
              />

      <DialogInput
                value = {this.formulaire.nbst}
                disabled={false}
                autoFocus = {false}
                readOnly = {true}
                width = "140px"
                title = {this.context.language=="fr"?"Nombre de sous-titres":"Subtitles count"}
              />
      <LanguageInput
                value = {this.formulaire.language}
                disabled={false}
                autoFocus = {false}
                ref = {this.languageRef}
                onChange =  {this.handleOnChange}
                readOnly = {false}
                width = "400px"
                title = {this.context.language=="fr"?"Langage":"File to Language"}
              />


      

      </>
    )

    return super.render(retour);
  }


}


export default AddSRT;